import React from "react"
import { Table, TableProps } from "antd"

const TableCustom = ({ ...tableProps }: TableProps<any>) => {
  return (
    <Table
      {...tableProps}
      footer={() => (
        <div
          style={{ display: "flex", flexDirection: "row-reverse", height: 30 }}
        >
          <p style={{ paddingTop: 3 }}>{tableProps.dataSource?.length} items</p>
        </div>
      )}
    />
  )
}

export default TableCustom
